import { render, staticRenderFns } from "./VehicleForm.vue?vue&type=template&id=3b8b2578"
import script from "./VehicleForm.vue?vue&type=script&lang=js"
export * from "./VehicleForm.vue?vue&type=script&lang=js"
import style0 from "./VehicleForm.vue?vue&type=style&index=0&id=3b8b2578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports